import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getImgUrl() {
  return Cookies.get('imgUrl')
}

export function setImgUrl(url) {
  return Cookies.set('imgUrl', url)
}

export function setVideoUrl(val) {
  return Cookies.set('videoUrl', val)
}

export function getVideoUrl() {
  return Cookies.get('videoUrl')
}



// WEBPACK FOOTER //
// ./src/utils/auth.js